import React from 'react';
const webGesture = (props) => {
    // eslint-disable-next-line react-native/no-inline-styles
    return React.createElement("div", { style: { flex: 1 } }, props.children);
};
const GestureHandlerRootView = webGesture;
const GestureDetector = React.Fragment;
const Gesture = React.Fragment;
export { GestureHandlerRootView, GestureDetector, Gesture };
